import moment from 'moment';

export const compareNumerRule = function (value, name) {
  let ruleData = {
    name,
    type: 'int',
    operation: value.operand,
    value: value.value,
  };
  if (value.operand === 'between') {
    ruleData = {
      fieldConditionList: [
        { value: value.value.startValue, operation: '>=', name, type: 'int' },
        { value: value.value.endValue, operation: '<=', name, type: 'int' },
      ],
      relation: 'and',
    };
  }
  return ruleData;
};
export const compareNumerText = function (opVal, ref, uint) {
  const { operand, value } = opVal;
  if (operand === 'between') {
    return `在${value.startValue + uint}至${value.endValue + uint}之间`;
  }
  const compareText = ref.compare && ref.compare.$refs.selector.currentOptions.find(obj => operand === obj.value).text;
  return `${compareText}${value + uint}`;
};

export const dateRule = function (value, name) {
  let ruleData = {
    name,
    type: 'date',
    operation: value.operand,
    value: moment(value.value.startValue).format('YYYYMMDD'),
  };
  if (value.operand === 'between') {
    const rule = {
      name,
      relation: 'and',
      fieldConditionList: [
        { operation: '>=', type: 'date', value: moment(value.value.startValue).format('YYYYMMDD'), name },
        { operation: '<=', type: 'date', value: moment(value.value.endValue).format('YYYYMMDD'), name },
      ],
    };
    ruleData = rule;
  }
  return ruleData;
};
export const dateText = function (opVal, ref) {
  const { operand, value } = opVal;

  if (operand === 'between') {
    return `在${moment(value.startValue).format('YYYY-MM-DD')}至${moment(value.endValue).format('YYYY-MM-DD')}之间`;
  }
  const compareText = ref.compare && ref.compare.$refs.selector.currentOptions.find(obj => operand === obj.value).text;
  return `${compareText}${moment(value.startValue).format('YYYY-MM-DD')}`;
};
